<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <h4 class="cf-title cf-title--4">
      Shipping Method
    </h4>

    <div
      v-if="shipping.methodsAreLoading && !shipping.selectedMethodId"
      class="loader"
    />

    <div
      v-else-if="shipping.methods.length > 0"
      class="cf-flex cf-flex--column cf-flex--gap-8"
    >
      <label
        v-for="method in shipping.methods"
        :key="method.identifier"
        class="cf-card cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16"
        :for="`shippingMethod${method.identifier}`"
      >
        <div class="cf-flex cf-flex--row cf-flex--no-shrink">
          <div class="cf-checkbox-input cf-checkbox-input--radio cf-checkbox-input--default cf-checkbox-input--no-label-text">
            <div class="cf-checkbox-input__option">
              <input
                :id="`shippingMethod${method.identifier}`"
                class="cf-checkbox-input__input"
                type="radio"
                name="shippingMethod"
                :value="method.identifier"
                :checked="method.identifier === shipping.selectedMethodId"
                @input="changeMethodHandler(method)"
              >

              <div class="cf-checkbox-input__label" />
            </div>
          </div>
        </div>

        <div class="cf-flex cf-flex--column cf-flex--grow-1">
          <h4 class="cf-title cf-title--4">
            {{ method.shippingMethodName }}
          </h4>

          <p class="cf-subtitle cf-subtitle--2">
            {{ method.shippingMethodDescription }}
          </p>
        </div>

        <div class="cf-flex cf-flex--row cf-flex--no-shrink">
          <p class="cf-subtitle cf-subtitle--2">
            {{ $dollars(method.fee) }}
          </p>
        </div>
      </label>
    </div>

    <div
      v-else
      class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10 cf-alt-background"
    >
      <span class="cf-icon cf-icon--red far fa-exclamation-circle" />

      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
        No shipping methods are currently available for your order.
      </p>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'ShippingMethodSelector',

    computed: {
      ...mapGetters('orders', ['order']),
      ...mapGetters('shipping', ['shipping'])
    },

    watch: {
      'order.subtotal': {
        handler: 'loadMethods',
        immediate: true
      }
    },

    methods: {
      changeMethodHandler(method) {
        this.$store.dispatch('shipping/selectMethod', method.identifier);
      },

      loadMethods() {
        this.$store.dispatch('shipping/getMethods');
      }
    }
  };
</script>
